'use client';

import { useCallback } from 'react';
import type { CustomerNotification } from '@/entities/customer-notification/api/customer-notifications/types';
import { isNewsUnread } from './is-news-unread';
import { useGuestNewsReadIds } from './news-read-storage';

export const useNewsUnread = () => {
    const readIds = useGuestNewsReadIds();

    const isUnread = useCallback(
        (item: Pick<CustomerNotification, 'id' | 'isRead'>) => isNewsUnread(item, { readIds }),
        [readIds],
    );

    const unreadCount = useCallback(
        (items: Pick<CustomerNotification, 'id' | 'isRead'>[]) =>
            items.filter((item) => isUnread(item)).length,
        [isUnread],
    );

    return { isUnread, unreadCount };
};
